// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { ProjectHeader_ProjectFragmentDoc } from '../../projects/ProjectHeader.generated';
import { NamedFragmentDoc } from '../../../fragments/commonFragments.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../queries/fragments.generated';
import { BidPackagesPage_BidPackageVersionFragmentDoc } from '../BidPackagesPage.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type BidPackagesPageV2MetadataQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BidPackagesPageV2MetadataQuery = { __typename?: 'Query', community: { __typename?: 'Community', biddingStartedAt?: Types.Scalars['DateTime']['input'] | null | undefined, biddingCompletedAt?: Types.Scalars['DateTime']['input'] | null | undefined, id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, name: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }>, parentsRecursive: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    >, siblingProjects: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
    > }, bidPackages: { __typename?: 'BidPackagesPageResult', entities: Array<{ __typename?: 'BidPackage', id: string, name: string, costCodesName: string, isUnitBased: boolean, isPlanBasedV2: boolean, isMissingOptions: boolean, isMissingCosts: boolean, updatedAt: Types.Scalars['DateTime']['input'], lastAwardedAt?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
            | { __typename?: 'ReadyPlan', id: string, name: string }
            | { __typename?: 'PlanPackage', id: string, name: string }
            | { __typename?: 'DesignPackage', id: string, name: string }
            | { __typename?: 'ProductOffering', id: string, name: string }
           }> }, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType, name: string } | null | undefined } | null | undefined }>, projects: Array<
        | { __typename?: 'StandaloneProject', id: string, name: string }
        | { __typename?: 'Region', id: string, name: string }
        | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
        | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
        | { __typename?: 'Subdivision', id: string, name: string }
        | { __typename?: 'Lot', id: string, name: string }
        | { __typename?: 'Structure', id: string, name: string }
        | { __typename?: 'Unit', id: string, name: string }
      > }> }, costCodes: Array<{ __typename?: 'CostCode', id: string, name: string }>, enumDetails: { __typename?: 'AllEnumDetails', bidPackageStatus: Array<{ __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }> } };

export type SaveBiddingCycleMutationVariables = Types.Exact<{
  input: Types.SaveCommunityInput;
}>;


export type SaveBiddingCycleMutation = { __typename?: 'Mutation', saveCommunity: { __typename?: 'SaveCommunityResult', community: { __typename?: 'Community', id: string, biddingStartedAt?: Types.Scalars['DateTime']['input'] | null | undefined, biddingCompletedAt?: Types.Scalars['DateTime']['input'] | null | undefined } } };

export type BidPackagesPageV2QueryVariables = Types.Exact<{
  filter: Types.CostCodeBidSummariesFilter;
  bidPackagesFilter?: Types.InputMaybe<Types.BidPackagesFilter>;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type BidPackagesPageV2Query = { __typename?: 'Query', costCodeBidSummaries: { __typename?: 'CostCodeBidSummariesPageResult', entities: Array<{ __typename?: 'CostCodeBidSummary', id: string, flags: Array<Types.CostCodeBidSummaryFlag>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string }, status: { __typename?: 'CostCodeBidSummaryStatusDetail', code: Types.CostCodeBidSummaryStatus, name: string }, bidPackages: Array<{ __typename?: 'BidPackage', id: string }> }> } };

export type BidPackagesPageV2CostCodeSummaryQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type BidPackagesPageV2CostCodeSummaryQuery = { __typename?: 'Query', community: { __typename?: 'Community', id: string, costCodeBidSummaryReport: { __typename?: 'ProjectCostCodeBidSummaryReport', totalStatuses: number, totalFlags: number, statusItems: Array<{ __typename?: 'CostCodeBidSummaryReportStatusItem', id: string, count: number, percentage: number, status: { __typename?: 'CostCodeBidSummaryStatusDetail', name: string, code: Types.CostCodeBidSummaryStatus } }>, flagItems: Array<{ __typename?: 'CostCodeBidSummaryReportFlagItem', id: string, count: number, flags: Array<{ __typename?: 'CostCodeBidSummaryFlagDetail', name: string, code: Types.CostCodeBidSummaryFlag, isLevelOne: boolean, isLevelTwo: boolean }> }> } } };

export type BidPackagesPageV2_CommunityCostCodeSummaryReportFragment = { __typename?: 'Community', id: string, costCodeBidSummaryReport: { __typename?: 'ProjectCostCodeBidSummaryReport', totalStatuses: number, totalFlags: number, statusItems: Array<{ __typename?: 'CostCodeBidSummaryReportStatusItem', id: string, count: number, percentage: number, status: { __typename?: 'CostCodeBidSummaryStatusDetail', name: string, code: Types.CostCodeBidSummaryStatus } }>, flagItems: Array<{ __typename?: 'CostCodeBidSummaryReportFlagItem', id: string, count: number, flags: Array<{ __typename?: 'CostCodeBidSummaryFlagDetail', name: string, code: Types.CostCodeBidSummaryFlag, isLevelOne: boolean, isLevelTwo: boolean }> }> } };

export type BidPackagesPageV2_FlagItemFragment = { __typename?: 'CostCodeBidSummaryReportFlagItem', id: string, count: number, flags: Array<{ __typename?: 'CostCodeBidSummaryFlagDetail', code: Types.CostCodeBidSummaryFlag, name: string, isLevelOne: boolean, isLevelTwo: boolean }> };

export type BidPackagesPageV2_CostCodeBidSummaryFragment = { __typename?: 'CostCodeBidSummary', id: string, flags: Array<Types.CostCodeBidSummaryFlag>, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, costCode: { __typename?: 'CostCode', id: string, number: string, name: string }, status: { __typename?: 'CostCodeBidSummaryStatusDetail', code: Types.CostCodeBidSummaryStatus, name: string }, bidPackages: Array<{ __typename?: 'BidPackage', id: string }> };

export type BidPackagesPageV2_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, costCodesName: string, isUnitBased: boolean, isPlanBasedV2: boolean, isMissingOptions: boolean, isMissingCosts: boolean, updatedAt: Types.Scalars['DateTime']['input'], lastAwardedAt?: Types.Scalars['DateTime']['input'] | null | undefined, status: { __typename?: 'BidPackageStatusDetail', code: Types.BidPackageStatus, name: string }, costType: { __typename?: 'CostTypeDetail', code: Types.CostType, name: string }, bidPackageGroup?: { __typename?: 'BidPackageGroup', id: string } | null | undefined, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, latestVersion: { __typename?: 'BidPackageVersion', id: string, version: number, displayVersion: string, readyPlanAggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, displayVersion: string, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
       }> }, activeBidders: Array<{ __typename?: 'BidPackageBidder', id: string, name: string, kind: Types.BidPackageBidderKind, bidContract?: { __typename?: 'BidContract', id: string, internalEstimateType?: { __typename?: 'InternalEstimateTypeDetail', code: Types.InternalEstimateType, name: string } | null | undefined } | null | undefined }>, projects: Array<
    | { __typename?: 'StandaloneProject', id: string, name: string }
    | { __typename?: 'Region', id: string, name: string }
    | { __typename?: 'Market', id: string, name: string, children: Array<{ __typename?: 'Community', id: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }> }
    | { __typename?: 'Community', id: string, name: string, productOfferings: Array<{ __typename?: 'ProductOffering', id: string, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus } }> }
    | { __typename?: 'Subdivision', id: string, name: string }
    | { __typename?: 'Lot', id: string, name: string }
    | { __typename?: 'Structure', id: string, name: string }
    | { __typename?: 'Unit', id: string, name: string }
  > };

export const BidPackagesPageV2_CommunityCostCodeSummaryReportFragmentDoc = gql`
    fragment BidPackagesPageV2_CommunityCostCodeSummaryReport on Community {
  id
  costCodeBidSummaryReport {
    statusItems {
      id
      count
      status {
        name
        code
      }
      percentage
    }
    flagItems {
      id
      count
      flags {
        name
        code
        isLevelOne
        isLevelTwo
      }
    }
    totalStatuses
    totalFlags
  }
}
    `;
export const BidPackagesPageV2_FlagItemFragmentDoc = gql`
    fragment BidPackagesPageV2_FlagItem on CostCodeBidSummaryReportFlagItem {
  id
  count
  flags {
    code
    name
    isLevelOne
    isLevelTwo
  }
}
    `;
export const BidPackagesPageV2_CostCodeBidSummaryFragmentDoc = gql`
    fragment BidPackagesPageV2_CostCodeBidSummary on CostCodeBidSummary {
  id
  costType {
    code
    name
  }
  costCode {
    id
    number
    name
  }
  status {
    code
    name
  }
  flags
  bidPackages(filter: $bidPackagesFilter) {
    id
  }
}
    `;
export const BidPackagesPageV2_BidPackageFragmentDoc = gql`
    fragment BidPackagesPageV2_BidPackage on BidPackage {
  id
  name
  costCodesName
  isUnitBased
  isPlanBasedV2
  isMissingOptions
  isMissingCosts
  updatedAt
  lastAwardedAt
  status {
    code
    name
  }
  costType {
    code
    name
  }
  bidPackageGroup {
    id
  }
  canDelete {
    ...PotentialOperationDetails
  }
  latestVersion {
    ...BidPackagesPage_BidPackageVersion
  }
  activeBidders {
    id
    name
    kind
    bidContract {
      id
      internalEstimateType {
        code
        name
      }
    }
  }
  projects {
    ...Named
    ... on Community {
      id
      productOfferings {
        id
        status {
          code
        }
      }
    }
    ... on Market {
      id
      children {
        id
        productOfferings {
          id
          status {
            code
          }
        }
      }
    }
  }
}
    ${PotentialOperationDetailsFragmentDoc}
${BidPackagesPage_BidPackageVersionFragmentDoc}
${NamedFragmentDoc}`;
export const BidPackagesPageV2MetadataDocument = gql`
    query BidPackagesPageV2Metadata($projectId: ID!, $page: PageFilter) {
  community(id: $projectId) {
    ...ProjectHeader_Project
    biddingStartedAt
    biddingCompletedAt
    productOfferings {
      ...Named
      status {
        code
      }
    }
  }
  bidPackages(
    filter: {project: [$projectId], includeParentProjectBids: true}
    page: $page
  ) {
    entities {
      ...BidPackagesPageV2_BidPackage
    }
  }
  costCodes(filter: {version: 2}) {
    ...Named
  }
  enumDetails {
    bidPackageStatus {
      code
      name
    }
  }
}
    ${ProjectHeader_ProjectFragmentDoc}
${NamedFragmentDoc}
${BidPackagesPageV2_BidPackageFragmentDoc}`;

/**
 * __useBidPackagesPageV2MetadataQuery__
 *
 * To run a query within a React component, call `useBidPackagesPageV2MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackagesPageV2MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackagesPageV2MetadataQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBidPackagesPageV2MetadataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables> & ({ variables: BidPackagesPageV2MetadataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>(BidPackagesPageV2MetadataDocument, options);
      }
export function useBidPackagesPageV2MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>(BidPackagesPageV2MetadataDocument, options);
        }
// @ts-ignore
export function useBidPackagesPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>;
export function useBidPackagesPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2MetadataQuery | undefined, BidPackagesPageV2MetadataQueryVariables>;
export function useBidPackagesPageV2MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>(BidPackagesPageV2MetadataDocument, options);
        }
export type BidPackagesPageV2MetadataQueryHookResult = ReturnType<typeof useBidPackagesPageV2MetadataQuery>;
export type BidPackagesPageV2MetadataLazyQueryHookResult = ReturnType<typeof useBidPackagesPageV2MetadataLazyQuery>;
export type BidPackagesPageV2MetadataSuspenseQueryHookResult = ReturnType<typeof useBidPackagesPageV2MetadataSuspenseQuery>;
export type BidPackagesPageV2MetadataQueryResult = ApolloReactCommon.QueryResult<BidPackagesPageV2MetadataQuery, BidPackagesPageV2MetadataQueryVariables>;
export const SaveBiddingCycleDocument = gql`
    mutation SaveBiddingCycle($input: SaveCommunityInput!) {
  saveCommunity(input: $input) {
    community {
      id
      biddingStartedAt
      biddingCompletedAt
    }
  }
}
    `;

/**
 * __useSaveBiddingCycleMutation__
 *
 * To run a mutation, you first call `useSaveBiddingCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBiddingCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBiddingCycleMutation, { data, loading, error }] = useSaveBiddingCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBiddingCycleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveBiddingCycleMutation, SaveBiddingCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveBiddingCycleMutation, SaveBiddingCycleMutationVariables>(SaveBiddingCycleDocument, options);
      }
export type SaveBiddingCycleMutationHookResult = ReturnType<typeof useSaveBiddingCycleMutation>;
export type SaveBiddingCycleMutationResult = ApolloReactCommon.MutationResult<SaveBiddingCycleMutation>;
export const BidPackagesPageV2Document = gql`
    query BidPackagesPageV2($filter: CostCodeBidSummariesFilter!, $bidPackagesFilter: BidPackagesFilter, $page: PageFilter) {
  costCodeBidSummaries(filter: $filter, page: $page) {
    entities {
      ...BidPackagesPageV2_CostCodeBidSummary
    }
  }
}
    ${BidPackagesPageV2_CostCodeBidSummaryFragmentDoc}`;

/**
 * __useBidPackagesPageV2Query__
 *
 * To run a query within a React component, call `useBidPackagesPageV2Query` and pass it any options that fit your needs.
 * When your component renders, `useBidPackagesPageV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackagesPageV2Query({
 *   variables: {
 *      filter: // value for 'filter'
 *      bidPackagesFilter: // value for 'bidPackagesFilter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useBidPackagesPageV2Query(baseOptions: ApolloReactHooks.QueryHookOptions<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables> & ({ variables: BidPackagesPageV2QueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>(BidPackagesPageV2Document, options);
      }
export function useBidPackagesPageV2LazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>(BidPackagesPageV2Document, options);
        }
// @ts-ignore
export function useBidPackagesPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>;
export function useBidPackagesPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2Query | undefined, BidPackagesPageV2QueryVariables>;
export function useBidPackagesPageV2SuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>(BidPackagesPageV2Document, options);
        }
export type BidPackagesPageV2QueryHookResult = ReturnType<typeof useBidPackagesPageV2Query>;
export type BidPackagesPageV2LazyQueryHookResult = ReturnType<typeof useBidPackagesPageV2LazyQuery>;
export type BidPackagesPageV2SuspenseQueryHookResult = ReturnType<typeof useBidPackagesPageV2SuspenseQuery>;
export type BidPackagesPageV2QueryResult = ApolloReactCommon.QueryResult<BidPackagesPageV2Query, BidPackagesPageV2QueryVariables>;
export const BidPackagesPageV2CostCodeSummaryDocument = gql`
    query BidPackagesPageV2CostCodeSummary($projectId: ID!) {
  community(id: $projectId) {
    ...BidPackagesPageV2_CommunityCostCodeSummaryReport
  }
}
    ${BidPackagesPageV2_CommunityCostCodeSummaryReportFragmentDoc}`;

/**
 * __useBidPackagesPageV2CostCodeSummaryQuery__
 *
 * To run a query within a React component, call `useBidPackagesPageV2CostCodeSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBidPackagesPageV2CostCodeSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBidPackagesPageV2CostCodeSummaryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useBidPackagesPageV2CostCodeSummaryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables> & ({ variables: BidPackagesPageV2CostCodeSummaryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>(BidPackagesPageV2CostCodeSummaryDocument, options);
      }
export function useBidPackagesPageV2CostCodeSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>(BidPackagesPageV2CostCodeSummaryDocument, options);
        }
// @ts-ignore
export function useBidPackagesPageV2CostCodeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>;
export function useBidPackagesPageV2CostCodeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<BidPackagesPageV2CostCodeSummaryQuery | undefined, BidPackagesPageV2CostCodeSummaryQueryVariables>;
export function useBidPackagesPageV2CostCodeSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>(BidPackagesPageV2CostCodeSummaryDocument, options);
        }
export type BidPackagesPageV2CostCodeSummaryQueryHookResult = ReturnType<typeof useBidPackagesPageV2CostCodeSummaryQuery>;
export type BidPackagesPageV2CostCodeSummaryLazyQueryHookResult = ReturnType<typeof useBidPackagesPageV2CostCodeSummaryLazyQuery>;
export type BidPackagesPageV2CostCodeSummarySuspenseQueryHookResult = ReturnType<typeof useBidPackagesPageV2CostCodeSummarySuspenseQuery>;
export type BidPackagesPageV2CostCodeSummaryQueryResult = ApolloReactCommon.QueryResult<BidPackagesPageV2CostCodeSummaryQuery, BidPackagesPageV2CostCodeSummaryQueryVariables>;